import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { useEffect } from 'react';
import Body from './components/Body';
import Footer from './components/Footer';
import Header from './components/Header';
import { UserProvider } from './context/UserContext';
import { TestingHqProvider } from './context/TestingHqContext';
import { TestingProvider } from './context/TestingContext';
import { DialogProvider } from './context/DialogContext';
import { ToastContainer } from 'react-toastify';
import Modal from 'react-modal';
import 'react-toastify/dist/ReactToastify.css';
import './App.css';
import Intro from './pages/intro'; // Intro 컴포넌트 import

function App() {
  // Modal의 App element 설정
  useEffect(() => {
    // #root 요소를 Modal의 App element로 설정
    Modal.setAppElement('#root');
    // 또는 document.body를 사용할 수도 있습니다
    // Modal.setAppElement(document.body);
  }, []);

  return (
    <Router>
      <UserProvider>
        <TestingHqProvider>
          <TestingProvider>
            <DialogProvider>
              <div className="App">
                <ToastContainer />
                <Routes>
                  <Route path="/" element={<Intro />} />
                  <Route
                    path="*"
                    element={
                      <>
                        <Header />
                        <Body />
                        <Footer />
                      </>
                    }
                  />
                </Routes>
              </div>
            </DialogProvider>
          </TestingProvider>
        </TestingHqProvider>
      </UserProvider>
    </Router>
  );
}

export default App;
